var React = require('react');

function Hamburger (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"id":"Hamburger_Rectangle","x":"0","y":"0","width":"12","height":"1.89473684","key":0}),React.createElement("rect",{"id":"Hamburger_Rectangle-Copy-2","x":"0","y":"10.1052632","width":"12","height":"1.89473684","key":1}),React.createElement("rect",{"id":"Hamburger_Rectangle-Copy-3","x":"0","y":"5.05263158","width":"12","height":"1.89473684","key":2})]);
}

Hamburger.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 12 12","version":"1.1","fill":"currentColor"};

module.exports = Hamburger;

Hamburger.default = Hamburger;
